import { render, staticRenderFns } from "./Lunch.vue?vue&type=template&id=458078e2&"
import script from "./Lunch.vue?vue&type=script&lang=js&"
export * from "./Lunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports